import { offer } from './offer'

export interface FaqItem {
  question: string
  answer: string
}

export const faqItems: FaqItem[] = [
  {
    question:
      'J’ai déjà une boîte à outils, et on trouve beaucoup de contenu gratuit.',
    answer:
      'Une boîte à outils contient des outils. Un parcours a besoin d’un ordre. À la quatrième séance, il ne manque pas une fiche de plus : il manque de savoir laquelle utiliser, et pourquoi maintenant. Ce système ne s’ajoute pas à vos outils. Il les séquence, de la Séance Zéro à la dixième séance.',
  },
  {
    question: 'J’ai déjà été formé(e) et certifié(e).',
    answer:
      'Tant mieux : ce système en a besoin. La formation vous a donné la posture et les compétences. Ceci vous donne l’architecture d’un parcours de dix séances — ce qui se passe en séance 1, en séance 4 et en séance 10. Il ne remplace ni votre formation, ni votre supervision.',
  },
  {
    question: 'N’est-ce pas trop directif pour une posture non directive ?',
    answer:
      'Non. La feuille de route est co-construite avec le client, et le contenu reste le sien. Le système structure le cadre, pas les réponses. Rendre le progrès visible ne revient pas à diriger le client : le cadre relève du coach, le changement relève du client.',
  },
  {
    question:
      'Six tomes, je n’aurai jamais le temps. Et j’ai déjà acheté des ressources que je n’ai jamais ouvertes.',
    answer:
      'Ce n’est pas une lecture à faire d’une traite. Le bonus Démarrage rapide vous dit quoi lire en priorité et quoi faire chaque jour pendant quatorze jours, et la fiche de préparation vous permet de préparer une séance en dix minutes. Ensuite, on ouvre le tome dont la séance du jour a besoin.',
  },
  {
    question: 'Je n’ai pas encore de clients, ou très peu.',
    answer:
      'C’est le meilleur moment. Installer le cadre avant votre premier parcours est plus simple qu’après le troisième décrochage. Et le Tome 6 couvre la séance découverte et la présentation d’un parcours, sans pression commerciale.',
  },
  {
    question: 'Est-ce adapté à la France, ou traduit de l’anglais ?',
    answer:
      'Écrit pour la France. Le Tome 6 traite de la micro-entreprise, du contrat d’accompagnement, du droit de rétractation, de la médiation, du RGPD, des titres protégés et de la loi du 10 mai 2024. Chaque tome intègre la frontière entre coaching et santé, avec une fiche d’orientation.',
  },
  {
    question:
      'Comment vais-je le recevoir ? Puis-je utiliser les fiches avec mes clients ?',
    answer:
      'Accès immédiat aux PDF après le paiement, lisibles sur tout appareil. Les fiches et le Carnet du coaché sont faits pour être imprimés et utilisés avec vos clients, en séance. La licence est individuelle : elle ne permet pas de revendre ni de diffuser le système.',
  },
  {
    question: 'Et si ce n’est pas pour moi ?',
    answer: `Vous avez ${offer.guaranteeDays} jours. Si le système ne vous convient pas, nous vous remboursons intégralement, sans justification.`,
  },
]
